import React, { useEffect, useState } from "react";
import { Icon, Progress } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";

import { importConcilieantionRatio } from "../redux/actions/dashboard";
import { GetConciliationRatio } from "../graphql/dashboard";
import { HMRModal } from "./HistoricalMonthlyReconciliations/HMRModal";

export const ConciliationRatio = () => {
  const dispatch = useDispatch();

  const { selectedCompany } = useSelector((state) => state.companyList);
  let [variables, setVariables] = useState({
    companyId: selectedCompany.id,
    month: new Date(),
  });
  const { conciliationRatio } = useSelector((state) => state.dashboard);
  const { fetching, data, error, reexecuteQuery } = GetConciliationRatio(
    variables.companyId,
    variables.month
  );

  const [openHRMModal, setOpenHRMModal] = useState(false);

  useEffect(() => {
    if (reexecuteQuery)
      reexecuteQuery({ requestPolicy: "network-only" }, variables);
  }, [conciliationRatio?.update, variables.companyId]);
  useEffect(() => {
    setVariables({
      companyId: selectedCompany.id,
      month: new Date(),
    });
  }, [selectedCompany.id, conciliationRatio?.update]);
  useEffect(() => {
    if (!fetching && data) {
      dispatch(importConcilieantionRatio(data.getMonthlyMatchsRatio * 100));
    }
  }, [fetching, data]);

  const onClickConciliatorBarDiv = (e) => {
    e.preventDefault();
    setOpenHRMModal(true);
  }

  return (
    <div className="d-flex align-items-end gap-2" style={{ cursor: 'pointer' }} onClick={onClickConciliatorBarDiv}>

      <div className="conciliationBar">
        <div>
          <b>{parseFloat(conciliationRatio?.ratio || 0).toFixed(1)}% conciliado este mes</b>
        </div>
        <Progress percent={conciliationRatio?.ratio || 0} color="blue" />
      </div>

      <div style={{ marginBottom: '8px' }}>
        Expandir
        <Icon name={`${openHRMModal ? 'long arrow alternate up' : 'long arrow alternate down'}`} />
      </div>

      <HMRModal
        open={openHRMModal}
        setOpen={setOpenHRMModal}
      />

    </div>
  );
};
